<script setup lang="ts">
</script>

<template>
  <div>
    <router-view></router-view>
  </div>
</template>
